import { initializeLocalizedPricing } from './paddle_pricing.js';

/** Add provider-formatted price estimates to public marketing cards. */
export async function initMarketingPricing(rootEl = document) {
  const root = rootEl.querySelector('[data-marketing-pricing]');
  if (!root || root.dataset.marketingPricingInitialized === 'true') return;
  root.dataset.marketingPricingInitialized = 'true';

  root.querySelectorAll('[data-pricing-plan]').forEach((card) => {
    const planKey = card.dataset.pricingPlan;
    card.dataset.cy = `pricing-plan-${planKey}`;
    const action = card.querySelector('a, button');
    if (action) action.dataset.cy = `pricing-${planKey}-cta`;
  });

  if (root.dataset.paddlePreviewAvailable !== 'true') return;

  const priceIds = Object.fromEntries(
    [...root.querySelectorAll('[data-marketing-price-id]')].map((node) => [
      node.dataset.marketingPlan,
      node.dataset.marketingPriceId,
    ]),
  );
  const announcer = root.querySelector('[data-pricing-announcer]');
  const messages = root.querySelector('[data-pricing-messages]');

  try {
    await initializeLocalizedPricing({
      clientToken: root.dataset.paddleClientToken,
      environment: root.dataset.paddleEnvironment,
      priceIds,
      onReady: ({ previewLocalizedMonthlyPrice }) => {
        for (const [planKey, priceId] of Object.entries(priceIds)) {
          if (!priceId) continue;
          void previewLocalizedMonthlyPrice(planKey).then((formattedPrice) => {
            const card = root.querySelector(
              `[data-pricing-plan="${CSS.escape(planKey)}"]`,
            );
            const amount = card?.querySelector('.pricing-price-amount');
            const notes = card?.querySelectorAll('.pricing-price-note');
            if (!amount || !notes?.length) return;
            amount.textContent = formattedPrice;
            notes[0].textContent = root.dataset.paddleTaxEstimate || '';
            if (notes[1]) notes[1].hidden = true;
            if (announcer) announcer.textContent = messages?.dataset.messagePreviewReady || '';
          }).catch(() => {
            if (announcer) announcer.textContent = messages?.dataset.messagePreviewError || '';
          });
        }
      },
    });
  } catch (_error) {
    if (announcer) announcer.textContent = messages?.dataset.messagePreviewError || '';
  }
}
